<nb-card>
  <nb-card-header class="d-flex align-items-center">
    <morva-icons class="cursor-pointer" (click)="close()" icon="close"></morva-icons>
    <span class="me-1">راهنمای فرمول‌های دکس</span>
  </nb-card-header>
  <nb-card-body>
    <h3 class="mb-0 mt-1">راهنمای کلی</h3>
    <p>برای نوشتن فرمول بر طبق استاندارد DAX باید نام جدول در ‘ ’ قرار گیرد. نام ستون در [ ] و بعد از نام جدول قرار می‌گیرد.</p>
    <p class="example-title">مثال:</p>
    <div class="example-expression">'Orders'[customer_id]</div>
    <p>در صورت وجود تابع باید نام جدول و سپس نام ستون بعد از تابع قرار گیرد.</p>
    <p class="example-title">مثال:</p>
    <div class="example-expression">Min(‘orders’[quantity])</div>
    <br>
    <h3 class="mb-0 mt-1">راهنمای ساخت ستون</h3>
    <p>فرمول زیر دو ستون جدول را کنار هم قرار می‌دهد و یه ستون جدید به نام Fullname  می سازد.</p>
    <p class="example-title">مثال:</p>
    <div class="example-expression">Fullname= ‘orders’[firstname]&’orders’[lastname]</div>
    <p class="example-title attention-text">توجه:</p>
    <p>هنگام ساخت ستون، فرمول بر روی هر سطر جدول اعمال می‌شود و باید در انتخاب و یا استفاده از توابع در ستون دقت داشت.</p>
    <br>
    <h3 class="mb-0 mt-1">راهنمای ساخت معیار</h3>
    <p>فرمول زیر معیاری می سازد که در آن در هر سطح سود به دست آمده بر کل فروش درصد سود حاصله را حساب میکند.</p>
    <p class="example-title">مثال:</p>
    <div class="example-expression">PC1: Divide(sum(‘orders’[sales]),sum(‘orders’[profit]))</div>
    <p class="example-title attention-text">توجه:</p>
    <p>در ساخت معیار توابع در سطح نمودار و یا المان بصری اعمال می‌شوند و ساخت معیار به ازای دشبورد امکان پذیر است.</p>
    <br>
    <h3 class="mb-0 mt-1">راهنمای توابع دکس</h3>
    <p>در لینک زیر میتوانید لیست توابع دکس و راهنمایی آن‌ها را مشاهده کنید:</p>
    <div class="example-expression"><a tabindex="-1" target="_blank" href="https://dax.guide/">dax.guide</a></div>
    <br>
  </nb-card-body>
</nb-card>
